import React, { useEffect, useState } from "react";
import { Flex, Input, Checkbox, Dropdown } from "@fluentui/react-northstar";
import { useAuth } from "../contexts/authContext";
import { useApp } from "../contexts/appContext";
import { getSettings } from "../services/settingsService";
import { setClientSettings } from "../services/dataService";
import styles from "../common.module.scss";

const reportFilterItems = [
    { key: "ALL", header: "Zobrazit všechny výkazy" },
    { key: "FUTURE", header: "Skrýt budoucí výkazy" },
    { key: "LEAVE", header: "Skrýt budoucí dovolené" }
];

const Settings = () => {
    document.title = "Settings";
    const settings = getSettings();

    const [weeks, setWeeks] = useState(settings.weeksToLoad);
    const [sync, setSync] = useState(settings.syncWithOutlook);
    const [reportFilter, setReportFilter] = useState(settings.reportFilter ?? "ALL");
    const [copyLinks, setCopyLinks] = useState(settings.copyLinks);
    const { state: authState } = useAuth();
    const { accessToken: token } = authState;
    const { dispatch } = useApp();

    useEffect(() => {
        if (!token) { return; }
        setClientSettings(token, {
            weeksToLoad: weeks,
            syncWithOutlook: sync,
            reportFilter,
            copyLinks
        });
    }, [weeks, sync, reportFilter, copyLinks])

    const weeksChanged = async (_: any, data: any) => {
        const nr = parseInt(data.value, 0);
        setWeeks(isNaN(nr) ? 0 : nr);
    };

    const syncChanged = async (_: any, data: any) => {
        setSync(data.checked);
    };

    const reportFiltersChanged = async (_: any, data: any) => {
        setReportFilter(data.value.key);
        dispatch({ type: "SET_REPORT_FILTER", reportFilter: data.value.key });
    };

    const copyLinksChanged = async (_: any, data: any) => {
        setCopyLinks(data.checked);
    };

    const weekString = () => {
        if (weeks === 1) { return "týden"; }
        if (weeks > 1 && weeks < 5) { return "týdny"; }
        return "týdnů";
    };

    return (
        <Flex column gap="gap.medium" className={styles.formBody}>
            <Flex column gap="gap.small">
                <span>Počet týdnů, který se bude načítat</span>
                <Input value={weeks} onChange={weeksChanged} />
                <small>Aplikace bude načítat výkazy za poslední{weeks > 4 ? "ch" : ""} {weeks} {weekString()}.</small>
            </Flex>
            <Flex column gap="gap.small">
                <Checkbox label="Synchronizovat události s Outlook" checked={sync} onChange={syncChanged} />
                <small>Je-li synchronizace vypnuta, výkaz nebude vytvořen jako událost v Outlook kalendáři.</small>
            </Flex>
            <Flex column gap="gap.small">
                <span>Výchozí filtr výkazů</span>
                <Dropdown
                    defaultValue={reportFilterItems.find(x => x.key === reportFilter)?.header}
                    items={reportFilterItems}
                    onChange={reportFiltersChanged}
                    fluid
                />
                <small>Výběrem možnosti permanentně aktivujete filtr.</small>
            </Flex>
            <Flex column gap="gap.small">
                <Checkbox label="Kopírovat odkazy do schránky" checked={copyLinks} onChange={copyLinksChanged} />
                <small>Místo otevírání odkazu v prohlížeči kopírovat odkaz do schránky.</small>
            </Flex>
        </Flex>
    );
};

export default Settings;
